import React from "react";
import { Box } from "@mui/material";
import Navbar from "../Navbar";

const Layout = ({ children }) => (
  <Box
    sx={{
      minHeight: "100vh",
      width: "100%",
      maxWidth: "100vw",
      overflowX: "hidden",
      bgcolor: "#dde7ecff",
    }}
  >
    <Navbar />
    <Box
      component="main"
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      {children}
    </Box>
  </Box>
);

export default Layout;
